import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M32.126 9.14186C29.279 7.45644 25.9567 6.48907 22.4085 6.48907C11.8583 6.48907 3.30566 15.0417 3.30566 25.5919C3.30566 36.1421 11.8583 44.6948 22.4085 44.6948C32.9587 44.6948 41.5114 36.1421 41.5114 25.5919C41.5114 23.2101 41.0755 20.93 40.2789 18.8272",
		stroke: "#A5BAC9",
		strokeWidth: 1.75,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M44.6949 3.30524L24.5308 28.5104L14.4487 20.9489",
		stroke: "#004438",
		strokeWidth: 1.75,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIconCheck;
